$(document).ready(function () {  


  // dep1 hover 
  $(".menu-list > li").hover(function($e){
    var _hoverIndex =  $(this).index();    
    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(".multi_coll > .colitem").eq(_hoverIndex).addClass("dep1_hover");
    subHeight();
  }, function(){    
    //$(".multi_coll > .colitem").delay(10).removeClass("dep1_hover");
  })
  
    // dep2 hover
  $(".menu_dep1 .multi_coll > .colitem").hover(function($e){
    var _hoverIndex =  $(this).index();
    $(".menu_dep1  .menu-list > li").eq(_hoverIndex).addClass("hover");

    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(this).addClass("hover");
  }, function(){
    $(".menu_dep1  .menu-list > li").removeClass("hover");
    $(this).removeClass("hover");
  });

  // dep3 hover
  $(".menu_dep1 .menu_dep3").hover( function(){
    $(this).closest("li").addClass("on");
  }, function(){
    $(this).closest("li").removeClass("on");
  });

  // dep3 item hover
  $(".menu_dep3.dep3_bg .sub-list > li").hover( function(){
    var _dep3_id = $(this).attr("data-index");	
    $(".menu_dep2 > .sub-list > li[data-index="+_dep3_id+"]").addClass("on");
    subHeight();
  },function(){
    $(".menu_dep2 > .sub-list > li").removeClass("on");
  });

  function subHeight(){
      
    $(".LN000021 .multi_coll > .colitem > .sub-list").each(function(){
      var _h =  $(".gnb_col3 .multi_coll").height();
      $(this).css({ "min-height" : "auto" });
      $(this).css({ "min-height" : _h });
    }); 

    if($(".multi_coll").innerHeight() < $(".menu_dep3.dep3_bg > .sub-list").innerHeight()){
      $(".multi_coll").height( $(".menu_dep3.dep3_bg > .sub-list").innerHeight() );
    }
    console.log( $(".multi_coll").height(),  $(".menu_dep3.dep3_bg > .sub-list").innerHeight());
  }
  subHeight();



})//ready



  /*
  * trpColItemH_H           : 같은 col 아이템 높이를 같게
  * @param	$closest			  : 적용글래스
  * @param	$col			      : col 아이템 겟수
  */
  jQuery.fn.trpColItemHI = function( $col ){
    var _arr = [], _arr_temps = [], _arr_col=[];
    var _items  = $(this);
    var _colNum = $col;
    
    function each_set(){
      _items.css({ "min-height": "auto"});
      if(_colNum == 1){ return; }
      
      _items.each( function($i){
        $(this).css({ "min-height": 0 });
        _arr.push( $(this).innerHeight() );  // 높이값
        _arr_col.push( $(this) );					   // 아이템
        if( ($i + 1) % _colNum == 0 ){
          height_max(_arr_col, _arr);
          _arr = []; _arr_col=[];
        }
      });
      return false;
    };
    
    
    function height_max($coltimes, $arr){
      var _max = Math.max.apply(null, $arr);
      for( var i=0; i < $coltimes.length ; i++){
        $coltimes[i].css({ "min-height":  (Math.round(_max)) });
      }
    }
    each_set();
    
    return {
      setCol: function($col) { 
        _colNum = $col;
        each_set();
      }
    }
  };
